import { Box, Typography, Stack, Grid, CircularProgress } from "@mui/material";
import { InputControl, CustomeDialog } from "../../../shared";
import { usePOSSyncSettings } from "../hooks/usePOSSyncSettings";

export const Settings = () => {
  const {
    state,
    isLoading,
    isSaving,
    handleToggle,
    handleConfirmToggle,
    handleCancelToggle,
  } = usePOSSyncSettings();

  return (
    <Stack sx={{ backgroundColor: "#fff", padding: "24px" }}>
      <Grid container>
        <Grid item xs={4}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Cost sync to pos
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          gap={2}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Stack sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <InputControl
                type="switch"
                name="cost_sync_enabled"
                onChange={(e) => handleToggle(e.target.checked)}
                checked={state.cost_sync_enabled}
                disabled={isLoading || isSaving}
              />
              {isSaving && (
                <CircularProgress size={20} sx={{ color: "#637381" }} />
              )}
            </Box>
            <Stack direction={"row"} gap={1} p={1} alignItems={"start"}>
              <Box
                component="img"
                src="/icons/ic_info.svg"
                alt="info"
                sx={{ width: 20, height: 20, mt: 0.2 }}
              />
              <Typography variant="body2" sx={{ color: "#637381" }}>
                This setting controls whether finished product cost updates are
                synced to POS. If disabled, no cost changes will be synced to
                POS.
              </Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>

      <CustomeDialog
        open={state.confirmModal.open}
        handleClose={handleCancelToggle}
        title="Confirm Change"
        closeIcon={true}
        divider={false}
        content={
          <Box sx={{ p: 2, minWidth: 400 }}>
            <Typography>
              Are you sure you want to{" "}
              {state.confirmModal.pendingValue ? "enable" : "disable"} cost sync
              to POS?
            </Typography>
          </Box>
        }
        footer={{
          display: true,
          confirmButton: "Confirm",
          cancelButton: "Cancel",
          onConfirm: handleConfirmToggle,
          onCancel: handleCancelToggle,
          isDisabled: false,
        }}
      />
    </Stack>
  );
};
